import React from 'react';

import { POST_TYPE } from 'constants/global';

import CommentButton from '../../../../../../../../../shared/CommentButton';
import LikeButton from '../../../../../../../../../shared/LikeButton';
import { Container } from './styles';

interface InteractionButtonsProps {
  postId: string;
  postType: POST_TYPE;
  refetchReactions: () => void;
}

const InteractionButtons: React.FC<InteractionButtonsProps> = ({
  postId,
  postType,
  refetchReactions,
}) => {
  return (
    <Container>
      <LikeButton
        postId={postId}
        postType={postType}
        refetchReactions={refetchReactions}
      />
      <CommentButton />
    </Container>
  );
};

export default InteractionButtons;
